"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var CoachPlan = /*#__PURE__*/function () {
  function CoachPlan(client) {
    (0, _classCallCheck2["default"])(this, CoachPlan);
    this.client = client;
    this.resourceUrl = '/coach-plan';
  }

  (0, _createClass2["default"])(CoachPlan, [{
    key: "getClientsCoachingPlans",
    value: function getClientsCoachingPlans(clientId, query) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return this.client.get("/sows/clients/".concat(clientId).concat(query ? query : ''), args);
    }
  }, {
    key: "sowTerminateClient",
    value: function sowTerminateClient(clientId, sowId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client["delete"]("/sows/clients/".concat(clientId, "/coaching-sow/").concat(sowId), args);
    }
  }, {
    key: "getCoachingPlan",
    value: function getCoachingPlan(clientId, planId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client.get("/sows/clients/".concat(clientId, "/coaching-sow/").concat(planId), args);
    }
  }, {
    key: "getcoachingPlanPayment",
    value: function getcoachingPlanPayment(sowId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.get("/admin/sow/".concat(sowId, "/payment-history"), args);
    }
  }, {
    key: "getcoachingPlansession",
    value: function getcoachingPlansession(sowId) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return this.client.get("/session/sow/".concat(sowId), args);
    }
  }, {
    key: "updateCoachPlan",
    value: function updateCoachPlan(data, clientId, planId) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
        args[_key6 - 3] = arguments[_key6];
      }

      return this.client.put("/sows/clients/".concat(clientId, "/coaching-sow/").concat(planId), data, args);
    }
  }, {
    key: "createCoachingPlan",
    value: function createCoachingPlan(data, clientId) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        args[_key7 - 2] = arguments[_key7];
      }

      return this.client.post("/sows/clients/".concat(clientId, "/coaching-sow"), data, args);
    }
  }, {
    key: "getSowEmailPreview",
    value: function getSowEmailPreview(data) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return this.client.post("/sows/email-preview", data, args);
    }
  }, {
    key: "getFileURL",
    value: function getFileURL(coachId, contentType) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
        args[_key9 - 2] = arguments[_key9];
      }

      return this.client.get("/user/".concat(coachId, "/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "getCoachingPlanList",
    value: function getCoachingPlanList(search) {
      var url;

      if (search) {
        url = "/sows/list?search=".concat(search);
      } else {
        url = "/sows/list";
      }

      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "createGrowthPlan",
    value: function createGrowthPlan(data, clientId) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 2 ? _len11 - 2 : 0), _key11 = 2; _key11 < _len11; _key11++) {
        args[_key11 - 2] = arguments[_key11];
      }

      return this.client.post("/sows/clients/".concat(clientId, "/growth-sow"), data, args);
    }
  }, {
    key: "getGrowthSOW",
    value: function getGrowthSOW(clientId) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return this.client.get("/sows/clients/".concat(clientId, "/growth-sow"), args);
    }
  }, {
    key: "getUnassignedSOW",
    value: function getUnassignedSOW(type, status) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 2 ? _len13 - 2 : 0), _key13 = 2; _key13 < _len13; _key13++) {
        args[_key13 - 2] = arguments[_key13];
      }

      return this.client.get("/admin/assign-coach-to-sow/".concat(type, "/").concat(status), args);
    }
  }, {
    key: "assignCoachToSOW",
    value: function assignCoachToSOW(data) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        args[_key14 - 1] = arguments[_key14];
      }

      return this.client.post('/admin/assign-coach-to-sow', data, args);
    }
  }, {
    key: "discardPlan",
    value: function discardPlan(userId) {
      for (var _len15 = arguments.length, args = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
        args[_key15 - 1] = arguments[_key15];
      }

      return this.client.post("/admin/discard-plan/".concat(userId), args);
    }
  }, {
    key: "sendPaymentReminder",
    value: function sendPaymentReminder(sowId) {
      for (var _len16 = arguments.length, args = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
        args[_key16 - 1] = arguments[_key16];
      }

      return this.client.post("/sows/".concat(sowId, "/send-payment-mail"), args);
    }
  }, {
    key: "getScheduledEvents",
    value: function getScheduledEvents(sowId) {
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var url = "/sows/".concat(sowId, "/scheduled-events");
      var params = [];

      if (queryParams.sessionType) {
        params.push("sessionType=".concat(queryParams.sessionType));
      }

      if (params.length > 0) {
        url += "?".concat(params.join('&'));
      }

      for (var _len17 = arguments.length, args = new Array(_len17 > 2 ? _len17 - 2 : 0), _key17 = 2; _key17 < _len17; _key17++) {
        args[_key17 - 2] = arguments[_key17];
      }

      return this.client.get(url, args);
    }
  }]);
  return CoachPlan;
}();

exports["default"] = CoachPlan;